import { gql, useLazyQuery } from "@apollo/client";
import { useMemo, useState } from "react";
import useFetchTableData from "../../custom_hooks/useFetchTableData";
import useProcessData from "../../../CommonFunction/ProcessData";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import { Loading, LoadTable } from "../../Components";
import { RiListSettingsLine } from "react-icons/ri";
import PriceAndRateList from "../../Components/FormComponents/AddPriceList/PriceAndRateList";
import { useSelector } from "react-redux";
import { WarningToast } from "../../Components/ToastComponent/RectHotToast";

const queryFunction = (fields) => {
  const query = gql`
    query GetAllPriceListMaster {
      getAllPriceListMaster {
        _id
        Is_Lock
        ${fields?.join(" ")}
      }
    }
  `;
  return query;
};

const PriceList = () => {
  const [formData, setFormData] = useState([]);
  const [isLoader, setIsLoader] = useState(true);
  const Key = "Price_Lists_Master";
  const [isPriceListClicked, setIsPriceListClicked] = useState({ flag: false, data: {} });
  const fieldDataRedux = useSelector((store) => store.UniqueTableReducer);

  const config = useMemo(
    () => ({
      dataKey: "getAllPriceListMaster",
      dateKeys: ["createdAt", "updatedAt"],
      deleteKeys: ["__typename"],
      dateKeysWithoutTime: ["From_Date", "To_Date"],
    }),
    []
  );

  const [fetchAllPriceList, { loading: queryLoading, error, data }] = useLazyQuery(queryFunction(), {
    fetchPolicy: "network-only",
    onCompleted: () => {
      setIsLoader(false);
    },
    onError: () => {
      setIsLoader(false);
    },
  });

  const { loading } = useFetchTableData(queryFunction, fetchAllPriceList, setIsLoader, Key);

  const { loading: processDataLoading } = useProcessData(data, setFormData, config, error);

  const isLoading = queryLoading || processDataLoading || isLoader;

  const handlePriceListClick = () => {
    if (fieldDataRedux?.Price_Lists_Master?.Selected_Row?._id) {
      setIsPriceListClicked({ flag: true, data: fieldDataRedux?.Price_Lists_Master?.Selected_Row });
    } else {
      WarningToast("Please select one row");
    }
  };

  const openIcon = (
    <div onClick={handlePriceListClick} id="edit_icon_button">
      <RiListSettingsLine className={"icon_styling"} />
      <p className={"IconName"}>PRICE LIST</p>
    </div>
  );

  return (
    <>
      <div>
        <HeaderDiv title="Price Lists" TableKey={Key} MoreIcons={[openIcon]} />
        {isLoading ? (
          <Loading />
        ) : !formData?.length ? (
          <p className="DataNotAvailable">Data not Available</p>
        ) : (
          <>
            {(queryLoading || loading) && <div className="loader-line-div" />}
            <LoadTable title={Key} data={formData} loading={isLoading} error={error} />
          </>
        )}
      </div>
      {isPriceListClicked?.flag && (
        <PriceAndRateList setIsPriceListClicked={setIsPriceListClicked} PriceListData={isPriceListClicked?.data} />
      )}
    </>
  );
};

export default PriceList;
